/* eslint-disable promise/param-names */
import {
  AUTH_REQUEST,
  AUTH_LOGIN_WITH_CODE,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT
} from '../actions/auth';

import { USER_REQUEST, USER_CLEAR_DATA } from '../actions/user';
import { SHOW_WELCOME_DIALOG } from '../actions/welcome_dialog';
import Api from '@/services/Api';

// import Vue from 'vue'

const state = { 
  token: localStorage.getItem('access_token') || '',
  status: '', 
  hasLoadedOnce: false,
};
const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  getAuthToken: state => state.token,
};

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      Api().post('/auth', user)
        .then(function (response) {
          localStorage.setItem('access_token', response.data.access_token);
          commit(AUTH_SUCCESS, response);
          dispatch(USER_REQUEST)
          resolve(response);
        })
        .catch(function (error) {
          commit(AUTH_ERROR);
          reject(error);
        });
    })
  },
  [AUTH_LOGIN_WITH_CODE]: ({commit, dispatch}, code) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      Api().post('/auth_with_code', {code: code})
        .then(function (response) {
          localStorage.setItem('access_token', response.data.access_token);
          commit(AUTH_SUCCESS, response);
          dispatch(USER_REQUEST)
          resolve(response);
        })
        .catch(function (error) {
          commit(AUTH_ERROR);
          reject(error);
        });
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT);
      dispatch(USER_CLEAR_DATA);
      dispatch(SHOW_WELCOME_DIALOG, false);
      localStorage.clear();
      resolve();
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.token = response.data.access_token;

    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '';
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
